import { Provider, inject } from '@angular/core';
import { ShellStore } from '@partners/state';
import { GtmAdapterCardService } from './gtm-adapter-card.service';
import { GtmAdapterLoanService } from './gtm-adapter-loan.service';
import { GtmAdapterService } from './gtm-adapter.service';

export const provideGtmAdapterService = (): Provider => {
  return {
    provide: GtmAdapterService,
    useFactory: () => {
      const shellStore = inject(ShellStore);

      const canMatchLoan$$ = shellStore.matchLoan$$;
      const canMatchCard$$ = shellStore.matchCard$$;

      if (canMatchLoan$$()) {
        return new GtmAdapterLoanService();
      }
      if (canMatchCard$$()) {
        return new GtmAdapterCardService();
      }

      return new GtmAdapterService();
    }
  };
};
